import React from 'react';
import { FaUsers, FaBuilding, FaCoffee, FaChartLine } from 'react-icons/fa';

export const TAB_CONFIG = [
  { id: 'users', label: 'Kullanıcı İstatistikleri', icon: FaUsers },
  { id: 'userDetails', label: 'Departman/Büro Analizi', icon: FaBuilding },
  { id: 'products', label: 'Ürün Satış İstatistikleri', icon: FaCoffee },
  { id: 'consumption', label: 'Kullanıcı Ürün Tüketimi', icon: FaChartLine },
] as const;

export type TabId = typeof TAB_CONFIG[number]['id'];

interface TabNavigationProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ activeTab, onTabChange }) => (
  <div className="flex space-x-2 bg-white rounded-xl p-2 shadow-lg">
    {TAB_CONFIG.map((tab) => (
      <button
        key={tab.id}
        onClick={() => onTabChange(tab.id)}
        className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-medium transition-all duration-200 ${
          activeTab === tab.id
            ? 'bg-blue-600 text-white shadow-lg'
            : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
        }`}
      >
        <tab.icon className="w-5 h-5" />
        <span>{tab.label}</span>
      </button>
    ))}
  </div>
);

export default TabNavigation; 